import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import VentureCapitalFirm from "../views/pc/VentureCapitalFirm.vue";//搜索投资机构
import SearchProject from "../views/pc/SearchProject.vue";//搜索项目
import SearchCloudDocking from "../views/pc/SearchCloudDocking.vue";//搜索云对接
import DetailsLogIn from "../views/pc/DetailsLogIn.vue";//详情未登录
import InstitutionalInvestor from "../views/pc/InstitutionalInvestor.vue";//详情投资机构
import DockingDetails from "../views/pc/DockingDetails.vue";//对接详情
import Data from "../views/pc/Data.vue";//数据看板
// import DockingSystem from '../views/pc/DockingSystem.vue'
Vue.use(VueRouter);



const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path:'/VentureCapitalFirm',
    name:'VentureCapitalFirm',
    component: VentureCapitalFirm
    
  },
  {
    path:'/SearchProject',
    name:'SearchProject',
    component: SearchProject
    
  },
  {
    path:'/SearchCloudDocking',
    name:'SearchCloudDocking',
    component: SearchCloudDocking
    
  },
  {
    path:'/DetailsLogIn',
    name:'DetailsLogIn',
    component: DetailsLogIn
    
  },
  {
    path:'/InstitutionalInvestor',
    name:'InstitutionalInvestor',
    component: InstitutionalInvestor
  },
  {
    path:'/DockingDetails',
    name:'DockingDetails',
    component: DockingDetails
  },
  {
    path:'/Data',
    name:'Data',
    component: Data
  },
  
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

// 路由守卫
router.beforeEach((to, from, next) => {    
  // chrome
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  // safari
  window.pageYOffset = 0
  next()
})


export default router;
